import { useCardInformation } from '@hooks/useCardInformation';
import WarningBanner from '@monofront/design-system/components/WarningBanner';
import { useTranslations } from 'next-intl';
import React, { useEffect, useState } from 'react';
import { useCacheFirstAuthentication } from '@context/persistedAuthContext';
import { useRouter } from 'next/router';
import useLocalizedRoutes from '@hooks/i18n/useLocalizedRoutes';
import { RoutesEnum } from '@monofront/types';
import { useTagContextMatches } from '@hooks/businessContainer';
import { useUserTags } from '@monofront/business/hooks';

const CreditCardStatusBanner = () => {
  const tManageSubs = useTranslations('Account.manageMySubscriptionSection');
  const router = useRouter();
  const { getPath } = useLocalizedRoutes();
  const { isAuthenticated, isMember } = useCacheFirstAuthentication();
  const customerTags = useUserTags(useCacheFirstAuthentication);
  const [cardBannerContent, setCardBannerContent] = useState({
    title: '',
    text: '',
  });

  const { tagContextMatches } = useTagContextMatches();

  const {
    hasAtLeastOneMonthPastSinceExpirationDate,
    isCardInExpirationMonth,
    isDunning,
    getPaymentQuery,
    currentPaymentMethodLoading,
  } = useCardInformation();

  useEffect(() => {
    if (currentPaymentMethodLoading) {
      return;
    }

    if (isDunning) {
      setCardBannerContent({
        text: tManageSubs('paiementFailed'),
        title: tManageSubs('cardPaymentFailed'),
      });
    } else if (isCardInExpirationMonth()) {
      setCardBannerContent({
        text: tManageSubs('expiredSoon'),
        title: tManageSubs('cardExpiringSoon'),
      });
    } else if (hasAtLeastOneMonthPastSinceExpirationDate()) {
      setCardBannerContent({
        text: tManageSubs('expiredCard'),
        title: tManageSubs('cardExpired'),
      });
    }
  }, [getPaymentQuery?.getCurrentPaymentMethod, currentPaymentMethodLoading]);

  const isMemberOrFreeTrial = tagContextMatches('member OR free-trialer', {
    isMember,
    isAuthenticated,
    tags: { user: customerTags },
  });

  const isBannerVisible = isMemberOrFreeTrial && !!cardBannerContent.text;

  if (!isBannerVisible) {
    return null;
  }

  return (
    <WarningBanner
      text={cardBannerContent.text}
      title={cardBannerContent.title}
      buttonTitle={tManageSubs('updatePM')}
      onButtonClick={() => {
        router.push(getPath(RoutesEnum.MANAGE_MY_SUBSCRIPTION));
      }}
    />
  );
};

export default CreditCardStatusBanner;
